import { Fragment } from "react";

import { prop, define } from "@/components/builder/utils";

import BasePreview from "../../base";

function FormFeednbackMessagePreview({ ...props }) {
  return <>
    <BasePreview {...props}>
      <span>Field error feedback</span>
    </BasePreview>
  </>
}

export default define('form-feedback-message', FormFeednbackMessagePreview, Fragment)
  .shared(prop.share('FormFeedbackMessage', 'form-feedback-message'))
  .property(prop.predefined.customClass())
  .property(...prop.predefined.typography())
  .defaultProps({
    fontSize: 'xs',
    fontWeight: 'font-light',
    textColor: 'red-400',
  })
  .build()

